import { render, staticRenderFns } from "./TutorialSchool.vue?vue&type=template&id=81032f04&scoped=true&"
import script from "./TutorialSchool.vue?vue&type=script&lang=js&"
export * from "./TutorialSchool.vue?vue&type=script&lang=js&"
import style0 from "./TutorialSchool.vue?vue&type=style&index=0&id=81032f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81032f04",
  null
  
)

export default component.exports